import { ProgramDecision } from "../../../../../common/api/decimal/methods/course.ts";
import { FormattedMessage } from "react-intl";
import Toast from "../../../../../common/core-ui/Toast.tsx";
import { ReactNode } from "react";
import { SingleSpaceLiteral } from "common/core-ui/SingleSpaceLiteral.tsx";
import { ProgramScope } from "routes/home/common/courses/buildProgramDetails.ts";

interface ToastProps {
  programScope: ProgramScope;
  newProgramName: string;
  oldProgramName: string;
  oldProgram: ProgramDecision;
  newProgram: ProgramDecision;
  materialCount: number;
  onClose?: () => void;
  toastBody?: ReactNode;
}

export default function ProgramChangeSuccessToast({
  programScope,
  oldProgramName,
  newProgramName,
  oldProgram,
  newProgram,
  materialCount,
  onClose,
}: ToastProps) {
  function getHeading() {
    if (programScope === "ea_only") {
      if (newProgram === "no_program") {
        return (
          <FormattedMessage
            defaultMessage="You have opted out of {programName} and lost access to {materialCount, plural, =1 {1 required course material} other {# required course materials}}."
            values={{
              programName: oldProgramName,
              materialCount,
            }}
          />
        );
      }
      return (
        <FormattedMessage
          defaultMessage="You have opted in to {programName} and gained access to {materialCount, plural, =1 {1 required course material} other {# required course materials}}."
          values={{
            programName: newProgramName,
            materialCount,
          }}
        />
      );
    }
    if (newProgram === "no_program") {
      return (
        <FormattedMessage
          defaultMessage="You have opted out of all course material programs and lost access to {materialCount, plural, =1 {1 course material} other {# course materials}}."
          values={{ materialCount }}
        />
      );
    }
    if (oldProgram === "no_program") {
      return (
        <FormattedMessage
          defaultMessage="You have gained access to {materialCount, plural, =1 {1 course material} other {# course materials}} in {programName}."
          values={{ programName: newProgramName, materialCount }}
        />
      );
    }
    return (
      <FormattedMessage
        defaultMessage="You switched to {programName}."
        values={{
          programName: newProgramName,
        }}
      />
    );
  }

  function getBody() {
    const base = (
      <FormattedMessage defaultMessage="Billing will be updated in your student account." />
    );
    if (programScope === "ea_only" && newProgram === "no_program") {
      return (
        <span>
          {base}
          <SingleSpaceLiteral />
          <FormattedMessage defaultMessage="Check your student email for refund information." />
        </span>
      );
    }

    return <>{base}</>;
  }

  return (
    <Toast onClose={onClose} type="success" title={getHeading()}>
      {getBody()}
    </Toast>
  );
}
